import styled, { createGlobalStyle } from "styled-components";

import { Modal as ModalBase } from "@ubnt/store.core/lib/components/Modal";
import { BREAKPOINTS } from "@ubnt/store.core/lib/constants/layout";

const MODAL_CONTENT_CLASSNAME = "modal-content";
const MODAL_HEADER_CLASSNAME = "header-classname";
const OVERLAY_CLASSNAME = "overlay";

export const GlobalModalStyle = createGlobalStyle`
  .${OVERLAY_CLASSNAME} {
    backdrop-filter: blur(10px);
    z-index: 100000 !important;
  }
`;

export const Modal = styled(ModalBase).attrs({
  contentClassName: MODAL_CONTENT_CLASSNAME,
  headerClassName: MODAL_HEADER_CLASSNAME,
  overlayClassName: OVERLAY_CLASSNAME,
})`
  max-width: 788px;
  width: 100%;
  max-height: calc(100% - 32px);

  border-radius: 16px;

  margin: 16px;
  padding: 0px;

  background: linear-gradient(
      0deg,
      rgba(94, 94, 94, 0.06) 0%,
      rgba(94, 94, 94, 0.06) 100%
    ),
    rgba(255, 255, 255, 0.75);

  .${MODAL_CONTENT_CLASSNAME} {
    padding: 0;
    margin: 0;
    overflow: auto;
  }

  .${MODAL_HEADER_CLASSNAME} {
    [class*="closeButton"] {
      z-index: 10;
    }

    svg {
      width: 24px;
      height: 24px;
      color: #5e5e5e93;

      top: 20px;
      right: 20px;
    }
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    margin: 0;
    max-height: 100%;
    border-radius: 0;
  }
`;
